import { render, staticRenderFns } from "./StatisticsDashboard.vue?vue&type=template&id=4a01d7d6&scoped=true"
import script from "./StatisticsDashboard.vue?vue&type=script&lang=js"
export * from "./StatisticsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a01d7d6",
  null
  
)

export default component.exports